<template>
    <v-dialog v-model="isActive" width="400" @click:outside="closeHandle">
        <div class="shipment-wig-edit-barcode">
            <div class="shipment-wig-edit-barcode__header">
                <div class="shipment-wig-edit-barcode__title">
                    {{ $t('pages.shipments.editWigBarcode') }}
                </div>
                <v-btn icon color="#55595c" @click="closeHandle">
                    <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
            </div>
            <div class="shipment-wig-edit-barcode__body">
                <div class="shipment-wig-edit-barcode__input-wrapper">
                    <v-text-field
                        v-model="barcode"
                        dense
                        outlined
                        type="text"
                        :label="$t('pages.shipments.barcode')"
                        :error-messages="errors.barcode"
                        :rules="[rules.required]"
                        required
                        @input="errors.barcode = ''"
                    ></v-text-field>
                </div>
            </div>
            <div class="shipment-wig-edit-barcode__footer">
                <div class="shipment-wig-edit-barcode__actions">
                    <v-btn color="#55595c" dark small @click="closeHandle">
                        {{ $t('pages.shipments.cancel') }}
                    </v-btn>
                    <v-btn
                        color="#967adc"
                        dark
                        small
                        :loading="isSubmitting"
                        @click="confirmHandle"
                    >
                        {{ $t('pages.shipments.confirm') }}
                    </v-btn>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import modalsMixin from '@/mixins/modals.mixin'
import languageMixin from '@/mixins/language.mixin'
import popUpTypes from '@/types/pop-up-types'
import { actionTypes as modalNotificationActionTypes } from '@/store/modules/modal-notifications'
import { actionTypes as shipmentsActionTypes } from '@/store/modules/shipments'
import { mapActions } from 'vuex'

const { shipmentWigEditBarcode } = popUpTypes

export default {
    name: 'ShipmentWigEditBarcode',
    mixins: [modalsMixin, languageMixin],
    data() {
        return {
            selfName: shipmentWigEditBarcode,
            barcode: '',
            errors: {
                barcode: '',
            },
            isSubmitting: false,
            rules: {
                required: (value) => !!value || this.$t('pages.shipments.required'),
            },
        }
    },
    computed: {
        wigId: function () {
            return this.extraData?.wigId || null
        },
        wig: function () {
            return this.extraData?.wig || null
        },
    },
    watch: {
        isActive: function (value) {
            if (value) {
                this.barcode = this.wig?.barcode || ''
                this.errors = { barcode: '' }

                return
            }

            this.barcode = ''
            this.errors = { barcode: '' }
            this.isSubmitting = false
        },
    },
    methods: {
        ...mapActions('modalNotifications', {
            showError: modalNotificationActionTypes.error,
            showSuccess: modalNotificationActionTypes.success,
        }),
        ...mapActions('shipments', {
            updateBarcode: shipmentsActionTypes.updateWigBarcode,
        }),
        closeHandle: function () {
            this.onClose(this.selfName)
        },
        confirmHandle: async function () {
            if (!this.barcode || !this.barcode.trim()) {
                this.errors.barcode = this.$t('pages.shipments.required')
                return
            }

            if (!this.wigId) {
                this.showError(this.$t('pages.shipments.wigNotFound'))
                return
            }

            this.isSubmitting = true

            try {
                const formData = new FormData()
                const data = JSON.stringify({ barcode: this.barcode.trim() })
                formData.append('data', data)

                await this.updateBarcode({
                    wigId: this.wigId,
                    form: formData,
                })

                this.showSuccess(this.$t('pages.shipments.barcodeUpdated'))

                if (this.extraData?.onSuccess) {
                    this.extraData.onSuccess()
                }

                this.closeHandle()
            } catch (error) {
                console.error('Error updating barcode:', error)
                this.showError(
                    error?.response?.data?.message ||
                        this.$t('pages.shipments.errorUpdatingBarcode')
                )
            } finally {
                this.isSubmitting = false
            }
        },
    },
}
</script>

<style scoped lang="scss">
.shipment-wig-edit-barcode {
    background: $color-primary-light;
    padding: 15px 10px;

    &__header {
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__title {
        font-size: 18px;
        font-weight: 500;
    }

    &__body {
        margin-bottom: 15px;
    }

    &__input-wrapper {
        margin-bottom: 12px;
    }

    &__actions {
        display: flex;
        justify-content: space-between;
        gap: 12px;
    }
}
</style>

